var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45896 1.97075C9.02559 0.594636 10.9746 0.594643 11.5412 1.97075L13.4881 6.69884L17.8546 6.95569C19.3861 7.04578 19.9928 8.98221 18.7865 9.93001L15.1514 12.7861L16.6003 16.8912C17.1374 18.4129 15.4142 19.7335 14.0844 18.8193L10.0001 16.0113L5.91576 18.8193C4.58594 19.7335 2.86279 18.4129 3.39989 16.8912L4.84873 12.7861L1.2137 9.93001C0.00741096 8.98221 0.614082 7.04578 2.14554 6.95569L6.5121 6.69884L8.45896 1.97075ZM10.0001 2.60533L7.65474 8.30117L2.24341 8.61948L6.81811 12.2139L4.97154 17.4459L10.0001 13.9887L15.0286 17.4459L13.1821 12.2139L17.7568 8.61948L12.3454 8.30117L10.0001 2.60533Z",
    fill: "#D80587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.75a458514aa659b59746ed929389c22c.svg";
export { ForwardRef as ReactComponent };